<div
    class="landing-page__container"
    *ngIf="true"
    fxLayout="column"
    fxLayoutAlign="center center"
>
    <h1 class="landing-page__title">
        {{ "Sign in to the Student Portal" | translate }}
    </h1>

    <mat-button-toggle-group
        style="margin-bottom: 20px; width: 90%; max-width: 35rem;"
        name="registryType"
        aria-label="Register Using"
        [(ngModel)]="registerUsing"
    >
        <mat-button-toggle value="email" checked style="width: 50%;">{{ "Sign in using email" | translate }}</mat-button-toggle>
        <mat-button-toggle value="mobile" style="width: 50%;">{{ "Sign in using mobile" | translate }}</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-form-field *ngIf="registerUsing == 'email'" appearance="outline" class="landing-page__field">
        <mat-label>
            {{ "Email Address" | translate }}
        </mat-label>
        <input
            matInput
            type="email"
            [value]=""
        />
    </mat-form-field>

    <mat-form-field *ngIf="registerUsing == 'mobile'" appearance="outline" class="landing-page__field">
        <mat-label>
            {{ "Phone Number" | translate }}
        </mat-label>
        <input
            matInput
            type="tel"
            [value]=""
        />
    </mat-form-field>

    <mat-form-field appearance="outline" class="landing-page__field">
        <mat-label>
            {{ "Password" | translate }}
        </mat-label>
        <input
            matInput
            type="password"
        />
    </mat-form-field>

    <button
        class="landing-page__button"
        mat-flat-button
        color="primary"
        [disabled]="false"
        (click)="doClick"
        data-test="create-account"
    >
        <!-- <re-captcha
        #captchaRef="reCaptcha"
        (resolved)="onCaptchaResolve()"
        (error)="onCaptchaError($event)"
        siteKey="{{siteKey}}"
        size="invisible"
        ></re-captcha> -->

        {{ "Sign in" | translate }}
    </button>

    <button
        class="landing-page__button"
        *ngIf="true"
        [disabled]="false"
        mat-button
        color="accent"
        (click)="doClick"
        style="color: rgb(133, 133, 133); font-weight: 400"
    >
        {{ "Forgot password" | translate }}
    </button>
   
</div>
